import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-center mt-3">Loading...</div>;
  }

  if (!user) return <Navigate to={requireAdmin ? "/admin-login" : "/login"} />;
  if (requireAdmin && user.role !== 'admin') return <Navigate to="/" />;
  return children;
};

export default PrivateRoute; 